import { FacebookLink } from '../common/sharelinks/FacebookLink';
import { EmailLink } from '../common/sharelinks/EmailLink';
import { NextdoorLink } from '../common/sharelinks/NextdoorLink';
import { ClickToCopy } from '../common/sharelinks/ClickToCopy';
import { Svg } from '../common/Svg';

interface TeacherProfileShareBarProps {
    urlToShare: string,
    teacherId: number,
}

const TeacherProfileShareBar = ({
    urlToShare,
    teacherId,
}: TeacherProfileShareBarProps) => {
    return (
        <div className="teacher-profile-share-bar">
            <div className="container">
                <h2 className="thick">Can’t give today? Pass it on.</h2>
                <p className="subheader">On average, each share can inspire <b>$50</b> in donations by helping this teacher reach more people.</p>

                <div className="teacher-profile-share-tools">
                    <ClickToCopy
                        textToCopy={urlToShare}
                        getTrackingLink={window.getTrackingLink}
                        pageName={pageName}
                        className="teacher-profile-share-tool">
                        <Svg icon="ss-link" iconFamily="social-circle"/>
                        <span className="teacher-profile-share-tool-label">Copy link</span>
                    </ClickToCopy>

                    <FacebookLink
                        urlToShare={urlToShare}
                        pageName={pageName}
                        className="teacher-profile-share-tool"
                        getTrackingLink={window.getTrackingLink}
                        facebookAppId={facebookAppId}
                        skipClipboard={true}>
                        <Svg icon="ss-facebook" iconFamily="social-circle"/>
                        <span className="teacher-profile-share-tool-label">Facebook</span>
                    </FacebookLink>

                    <EmailLink
                        useSpan={true}
                        secure={false}
                        tafURL={`${secureBaseURL}donors/share_teacher_profile.html?teacher=${teacherId}`}
                        pageName={pageName}
                        getTafEmail={window.getTafEmail}
                        onEmailClick={() => {}}
                        className="teacher-profile-share-tool">
                        <span className="teacher-profile-share-tool-label">Email</span>
                    </EmailLink>

                    <NextdoorLink
                        useSpan={true}
                        skipTrackingParams={false}
                        urlToShare={urlToShare}
                        pageName={pageName}
                        getTrackingLink={window.getTrackingLink}
                        onNextdoorClick={(event, url) => {
                            event.preventDefault();
                            event.stopPropagation();
                            window.open(url, '_blank');
                        }}
                        schoolName=""
                        nextdoorShareBody="A chain reaction of support starts with one share. "
                        className="teacher-profile-share-tool">
                        <Svg icon="ss-nextdoor" iconFamily="social-circle"/>
                        <span className="teacher-profile-share-tool-label">Nextdoor</span>
                    </NextdoorLink>
                </div>
            </div>
        </div>
    );
};

export default TeacherProfileShareBar;
